export default "__VITE_ASSET__7850c35d__"